/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询周边商品
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class FindCommoditiesPeripheryParams {
  constructor(public page: number, public size: number) {}
}

export default async function (
  id: string,
  type: "COMMODITY_TOUR" | "COMMODITY_PRODUCT",

  params: FindCommoditiesPeripheryParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.CommodityDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/commodities/periphery/${id}/${type}`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
